export function fundProjectListConfig(getMoney, selectPersonClick, selectDeptClick) {
  return {
    menuType: "button",
    addBtn: false,
    menuWidth: 120,
    menuAlign: "center",
    card: true,
    menu: false,
    delBtn: false,
    editBtn: false,
    align: "center",
    searchMenuSpan: 8,
    columnBtn: false,
    searchBtn: true,
    index: true,
    indexLabel: "序号",
    refreshBtn: true,
    selection: true,
    selectionWidth: 50,
    searchShow: false,
    column: [
      {
        label: "合同编号",
        prop: 'number',
        width: '80',
        // overHidden: true,

      },
      {
        label: "合同名称",
        prop: "contractName",
        // width: "140",
        searchPlaceholder: "项目编号/项目名称",
        placeholder: "项目编号/项目名称",
        search: true,
        slot:true
      },
      {
        label: "审批状态",
        prop: "auditStatus",
        type: "select",
        search: true,
        dataType: 'number',
        dicUrl: "/api/blade-system/dict-biz/dictionary?code=project_build_state",
        props: {
          label: "dictValue",
          value: "dictKey",
        },
        display: false,
        // overHidden: true,
        width: '70',
      },
      // {
      //   label: '项目名称',
      //   prop: 'name',
      //   bind: 'dzReportVO.name',
      //   width: '160'
      // },      
      {
        label: "用印文件",
        prop: "file",
        slot: true,
        width: "120",
        display: true,
        // overHidden: true,

      },
      {
        label: "项目类型",
        prop: "projectType",
        bind: 'dzReportVO.dzProjectVO.projectType',
        type: "select",
        display: false,
        // overHidden: true,
        dataType: "number",
        dicUrl: '/api/blade-system/dict-biz/dictionary?code=zg_fund_projectType',
        props: {
          label: "dictValue",
          value: "dictKey"
        },
        width: '70'
      },
      {
        label: '证券名称',
        prop: 'securitiesName',
        bind: 'dzReportVO.dzProjectVO.securitiesName',
        width: '120'
      },
      {
        label: '证券代码',
        prop: 'securitiesNo',
        bind: 'dzReportVO.dzProjectVO.securitiesNo',
        width: '120'
      },
      {
        label: '合同金额(元)',
        prop: 'contractMoney',
        width: '100',
        formatter: (row, value, label, column) => {
          return `${getMoney(value)}`;
        } , 
      },
      {
        label: "经办人",
        prop: "managerUserName",
        display: true,
        width:70
      },
      // {
      //   label: '创建时间',
      //   prop: 'createTime',
      //   width: "150"
      // }
    ]
  }
}


export function fundContractAddConfig() {
  return {
    labelWidth: 200,
    emptyBtn: false,
    submitBtn: false,
    column: [
      {
        label: "合同名称",
        prop: "contractName",
        span: 8,
        overHidden: true,
        display: true,
        rules: [{
          required: true,
          message: "请输入项目名称",
          trigger: "blur",
        }],
      },
      {
        label: "合同金额",
        prop: "contractMoney",
        span: 8,
        overHidden: true,
        display: true,
        append: '元',
        rules: [{
          required: true,
          message: "请输入实际中标价值",
          trigger: "blur",
        }],
      }, 
      {
        label: "合同编号",
        prop: 'number',
        span: 8,
        placeholder: "-",
        disabled: true,
        formslot:true

      },
      {
        label: "项目名称",
        prop: "projectName",
        span: 8,
        overHidden: true,
        display: true,
        disabled: false,
        formslot: true,
        rules: [{
          required: true,
          message: "请输入内容",
          trigger: "blur",
        }],
      },
      {
        label: "项目类型",
        prop: "projectType",
        type: 'select',
        disabled:true,
        alwaysDisabled: true,
        span: 8,
        dicUrl: '/api/blade-system/dict-biz/dictionary?code=zg_fund_projectType',
        props: {
          label: "dictValue",
          value: "dictKey"
        },
      },
      
           
      {
        label: "证券名称",
        prop: "securitiesName",
        span: 8,
        disabled: true,
        alwaysDisabled: true,
        placeholder: "请选择项目"
      },
      {
        label: "证券代码",
        prop: "securitiesNo",
        span: 8,
        disabled: true,
        alwaysDisabled: true,
        placeholder: "请选择项目"
      },
      {
        label: "实际中标价值",
        prop: "actualValue",
        span: 8,
        overHidden: true,
        display: true,
        disabled: true,
        alwaysDisabled: true,
        append: '元'
      },
      {
        label: "实际中标数量",
        prop: "actualNum",
        span: 8,
        overHidden: true,
        display: true,
        disabled: true,
        alwaysDisabled: true,
        append: '股'
      },
      {
        label: "经办人",
        prop: "createUserName",
        span: 24,
        overHidden: true,
        display: true,
        disabled: true,
        alwaysDisabled: true
      }
    ]
  }
}
